export default function PlaceholderPage({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h1 className="text-xl font-bold text-portal-gray-900 mb-2">{title}</h1>
      <p className="text-sm text-portal-gray-500 mb-6">{description}</p>
      <div className="bg-white rounded-xl border border-portal-gray-200 p-8 text-center">
        <div className="w-12 h-12 bg-portal-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <i className="ri-settings-line text-portal-gray-400 text-xl"></i>
        </div>
        <p className="text-sm text-portal-gray-500">Esta funcionalidade será implementada na próxima fase.</p>
      </div>
    </div>
  );
}